import PatientTime from '../../../../components/PatientTime';
import { SlotHour } from '../../../../modules/slots';
import { useMemo } from 'react';
import { DisplayTimes } from '../index';

export type TimePickerProps = {
  slots: SlotHour[];
  value?: SlotHour;
  onValueChange?: (value: SlotHour) => void;
};

function formatSlotToDateTimes(slot: SlotHour): DisplayTimes {
  return { time: new Date(slot.date + 'T' + slot.hour), id: String(slot.scheduleId), slots: [slot] };
}

export function TimePicker({ value, slots, onValueChange }: TimePickerProps) {
  const times = useMemo<DisplayTimes[]>(() => {
    return slots.map(slot => formatSlotToDateTimes(slot));
  }, [slots]);

  const onSelectedTime = (value: DisplayTimes) => {
    onValueChange?.(value.slots[0]);
  };

  return (
    <PatientTime
      times={times}
      selectedTime={value ? formatSlotToDateTimes(value) : ({} as any)}
      onSelectedTime={onSelectedTime}
    />
  );
}
